import { getCurrentInstance, inject, isRef, onMounted, provide, Ref, ref } from 'vue';

export interface FocusProps {
    autofocus?: boolean,
}

/**
 * @deprecated nicht-typescript Variante um defineProps erfüllen zu können
 */
export const focusProps = {
    autofocus: {
        type: Boolean,
        default: false,
    },
};

export function useFocusComposable(input: Ref|null = null) {
    if (!isRef(input) && input !== null) {
        throw new Error('input must be a ref');
    }
    const { props } = getCurrentInstance() as { props: FocusProps };

    let isFocused: null|Ref<boolean> = inject('isFocused', null);
    if (isFocused === null) {
        isFocused = ref<boolean>(false);
        provide('isFocused', isFocused);
    }

    if (input === null) {
        input = ref(null);
    }
    function setInput(ref: any) {
        (input as Ref).value = ref;
    }
    function focus() {
        if ((input as Ref).value === null) {
            (isFocused as unknown as Ref).value = true;
            return;
        }
        (input as Ref).value.focus();
    }
    function blur() {
        if ((input as Ref).value === null) {
            (isFocused as unknown as Ref).value = false;
            return;
        }
        (input as Ref).value.blur();
    }

    onMounted(() => {
        if (!props.autofocus) {
            return;
        }
        focus();
    });

    return {
        isFocused: isFocused as unknown as Ref,
        setInput,
        focus,
        blur,
        exposes: {
            focus,
            blur,
        },
    };
}
